import { InternalPurchaserSchema, PurchaserStatus } from '@buyerflo/core/schemas/purchaser'
import { getPurchaserStatusOptions } from '@buyerflo/ui/utils/purchaser'
import { useUserData } from 'auth'

/** Max content width shared by every client (purchaser) detail tab. */
export const CLIENT_DETAIL_MAX_WIDTH = 900

export const usePurchaserStatusOptions = (
    purchaser: InternalPurchaserSchema,
): { value: PurchaserStatus; disabled?: boolean }[] => {
    const { user } = useUserData()
    return getPurchaserStatusOptions(purchaser, user.permissions)
}
